// eslint-disable-next-line monorepo/no-internal-import
import {useCanGoBack} from '@aboutyou/router/src/CanGoBack/CanGoBackContext';
import React, {createContext, useContext, useEffect, useState} from 'react';

let effectHasCalledOnce = false;

export function useHydrationDone() {
  const contextValue = useContext(Context);

  const isInsideHydrationBoundary =
    contextValue === true || contextValue === false;

  const [done, setDone] = useState(effectHasCalledOnce);

  useEffect(() => {
    if (isInsideHydrationBoundary) return; // if used within a `HydrationBoundary` do not execute this useEffect, instead use the value from the context

    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    setDone(true);
    effectHasCalledOnce = true;
  }, [isInsideHydrationBoundary]);

  return isInsideHydrationBoundary ? contextValue : done;
}

const Context = createContext<boolean | null>(null);

export const HydrationBoundary: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const canConsiderHydrationDone = useCanGoBack();
  /**
   * The state of hydration done can be assumed to be true if there was some navigation before the first render.
   * This allows to avoid an unnecessary re-render of the components which use `useHydrationDone` hook on the pages they navigate to next.
   */
  const [done, setDone] = useState<boolean>(canConsiderHydrationDone);

  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    setDone(true);
  }, []);

  return <Context.Provider value={done}>{children}</Context.Provider>;
};
